import React from 'react';
import { formatCurrency } from '../../Helpers/FormatUtils';

export interface CategoryTotal {
    key: string;
    label: string;
    yearly: number;
    color: string;
}

interface OperatingCostsSummaryProps {
    yearlyTotal: number;
    costCount: number;
    /** Per-category yearly totals, largest first. The breakdown shows when there are two or more. */
    categoryTotals: CategoryTotal[];
    /** Label of the active category filter, if any. */
    filterLabel?: string;
}

const OperatingCostsSummary: React.FC<OperatingCostsSummaryProps> = ({
    yearlyTotal,
    costCount,
    categoryTotals,
    filterLabel,
}) => {
    const showBreakdown = categoryTotals.length > 1 && yearlyTotal > 0;

    return (
        <div className="std-box operating-costs-summary">
            <div className="operating-costs-summary-label">
                Totalt per år{filterLabel && ` · ${filterLabel}`}
            </div>
            <div className="operating-costs-summary-total">{formatCurrency(yearlyTotal)}</div>
            <div className="operating-costs-summary-meta">
                ≈ {formatCurrency(yearlyTotal / 12)} per månad · {costCount} {costCount === 1 ? 'kostnad' : 'kostnader'}
            </div>

            {showBreakdown && (
                <>
                    <div className="operating-costs-summary-bar" aria-hidden="true">
                        {categoryTotals.map(cat => (
                            <span
                                key={cat.key}
                                style={{ flexGrow: cat.yearly, backgroundColor: cat.color }}
                                title={`${cat.label}: ${formatCurrency(cat.yearly)}/år`}
                            />
                        ))}
                    </div>
                    <ul className="operating-costs-summary-legend">
                        {categoryTotals.map(cat => (
                            <li key={cat.key}>
                                <span className="legend-dot" style={{ backgroundColor: cat.color }} />
                                <span className="legend-label">{cat.label}</span>
                                <span className="legend-share">{Math.round((cat.yearly / yearlyTotal) * 100)} %</span>
                                <span className="legend-amount">{formatCurrency(cat.yearly)}</span>
                            </li>
                        ))}
                    </ul>
                </>
            )}
        </div>
    );
};

export default OperatingCostsSummary;
